import { DateInputLocalized, ExportButtonDropdown, ExportType } from '@components'

import { Text } from '@billy/design-system'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'

import { useSegment } from '../../../../hooks'
import { formatDate } from '../../../../utils'
import { ExportsCard } from '../ExportsCard'

const CREDITOR_LIST_EXPORT_URL = 'creditorList'

export const CreditorList = () => {
  const { t } = useTranslation()
  const { downloadExportFile } = useDownloadExportFile()
  const { track } = useSegment()

  const [creditorListData, setCreditorListData] = useState<Date | undefined | null>(new Date())

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      downloadExportFile({
        exportUrl: CREDITOR_LIST_EXPORT_URL,
        type,
        queryParams: {
          date: formatDate(creditorListData),
        },
      })

      track('XXX - Mikkel - Exports', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        export_type: 'Accounts payable',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        file_format: type,
        period: formatDate(creditorListData),
      })
    },
    [creditorListData, downloadExportFile, track],
  )

  const handleChangeCreditorListData = useCallback(
    (date?: Date | null) => {
      setCreditorListData(date)
    },
    [setCreditorListData],
  )

  return (
    <ExportsCard
      description={t('exports.card.creditor_list.description')}
      title={t('exports.card.creditor_list.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html]}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    >
      <div>
        <Text colorVariant="label" weight="medium">
          {t('date')}
        </Text>
        <DateInputLocalized value={creditorListData} onChange={handleChangeCreditorListData} />
      </div>
    </ExportsCard>
  )
}
